import m from "mithril";

const Modal_ConfirmV2 = {
    view: function (vnode) {
        const { confirmCallback, cancelCallback, messageText, cancelButtonLabel, confirmButtonLabel, cancelButtonClasses, confirmButtonClasses, onModalClose } = vnode.attrs;

        const confirmOnClick = function() {
            if (confirmCallback) {
                confirmCallback();
            }
            if (onModalClose) {
                onModalClose();
            }
        };

        const cancelOnClick = function() {
            if (cancelCallback) {
                cancelCallback();
            }
            if (onModalClose) {
                onModalClose();
            }
        };

        return [
            m(".form-section", messageText),
            m(".form-buttons", [
                m(cancelButtonClasses ? cancelButtonClasses : "button", {onclick: cancelOnClick }, cancelButtonLabel),
                m(confirmButtonClasses ? confirmButtonClasses : "button.btn-error", { onclick: confirmOnClick }, confirmButtonLabel)
            ])
        ];
    }
};

export default Modal_ConfirmV2;
